<script>
    import Fa from 'svelte-fa'
    import {link,push,querystring} from 'svelte-spa-router'
    import * as qs from 'qs';
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faUserPlus,faHomeUser,faSignIn,faMinus,faMobileScreenButton,faCircleRight,faKey,faLock } from '@fortawesome/free-solid-svg-icons';
    import Swal from 'sweetalert2'

    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    let myLink = '/register'

    let username = ""
    let password = ""
    let password2 = ""
    let customerphone = ''
    let step1 = true
    let step2 = false
    let step3 = false

    let otp_num1 = ""
    let otp_num2 = ""
    let otp_num3 = ""
    let otp_num4 = ""

    let otp1
    let otp2
    let otp3
    let otp4
    

    let paramsx = new URLSearchParams($querystring);
	let logintoken = paramsx.get('token')

    let otp_token = ""


    async function setStep1() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"register/resetpasswordstep1", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                member_tel:customerphone,
            })
        })

        const json = await res.json()
        if (json.statusCode==200) {
            otp_token = json.payload.token
            step1 = false
            step2 = true
            step3 = false

		}else{
            Swal.fire({
                heightAuto: false,
                title: 'ไม่สามารถทำรายการได้',
                text: json.message,
                icon: 'error',
                confirmButtonText: 'OK' 
            })
        }
    }
    async function setStep2() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"register/resetpasswordstep2", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                token:otp_token,
                otp:otp_num1.toString()+otp_num2.toString()+otp_num3.toString()+otp_num4.toString()
            })
        })

        const json = await res.json()
        if (json.statusCode==200) {
            step1 = false
            step2 = false
            step3 = true
		}else{
            Swal.fire({
                heightAuto: false,
                title: 'ไม่สามารถทำรายการได้',
                text: json.message,
                icon: 'error',
                confirmButtonText: 'OK' 
            })
        }
    }
    async function setStep3() {
        if(password == "" || password2 == ""){
            Swal.fire({
                heightAuto: false,
                title: 'ไม่สามารถทำรายการได้',
                text: "กรุณาระบุรหัสผ่านให้ครบถ้วน",
                icon: 'error',
                confirmButtonText: 'OK' 
            })
            return
        }else{
            if(password!=password2){
                Swal.fire({
                    heightAuto: false,
                    title: 'ไม่สามารถทำรายการได้',
                    text: "รหัสผ่านไม่ตรงกัน",
                    icon: 'error',
                    confirmButtonText: 'OK' 
                })
                return
            }else{
                const res = await fetch(window.localStorage.getItem("apiurl")+"register/resetpasswordstep3", {
                    method: 'POST',
                    headers:{
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'x-api-appid': window.localStorage.getItem("appid")
                    },
                    body: qs.stringify({
                        token:otp_token,
                        member_password:password
                    })
                })
                const json = await res.json()
                if (json.statusCode==200) {
                    Swal.fire({
                        heightAuto: false,
                        title: 'ทำรายการสำเร็จ',
                        text: "",
                        icon: 'success',
                        confirmButtonText: 'OK' 
                    })
                    push("/auth")
                }else{
                    Swal.fire({
                        heightAuto: false,
                        title: 'ไม่สามารถทำรายการได้',
                        text: json.message,
                        icon: 'error',
                        confirmButtonText: 'OK' 
                    })
                }
            }
        }
    }


    $: {

	}
</script>
<div class="row pt-2"> 
    <div class="col-6">
        <a href="{dataSetting.homepage}" class="btn btn-outline-secondary btn-sm btn-gd" style="--bs-btn-padding-y: .10rem; --bs-btn-padding-x: .3rem; --bs-btn-font-size: .7rem;"><Fa icon={faHomeUser} /> หน้าหลัก</a>
    </div>
    <div class="col-6 text-end">
        <a href="{dataSetting.lineurl}" target="_blank"><span class="badge rounded-pill text-bg-success"><Fa icon={faLine} size="lg"/> {dataSetting.lineid}</span></a>
    </div>
    
    <div class="col-3 mt-5"></div>
    <div class="col-6 text-center mt-5">
        <img src="{dataSetting.logo}" class="img-fluid">
    </div>
    <div class="col-12 mt-3">
        <div class="card">
            <div class="card-body">
                {#if step1}
                <div class="row">
                    <div class="mb-3 text-center">
                        
                        <h6>รีเซ็ตรหัสผ่าน</h6>
                    </div>
                    <!-- <div class="cf-turnstile" data-sitekey="0x4AAAAAAACLn-OIe36odM6b" data-callback="javascriptCallback"></div> -->
                    <div class="mb-3">
                        <label for="customerphone" class="form-label"><Fa icon={faMobileScreenButton} /> เบอร์โทร</label>
                        <input type="text" class="form-control rounded-pill text-center" id="customerphone" placeholder="" bind:value={customerphone}>
                    </div>
                    
                    <div class="col-12 text-center d-grid gap-2">
                        <button type="button" class="btn btn-dark rounded-pill btn-gd"  on:click={() => setStep1()}  >ถัดไป <Fa icon={faCircleRight} /></button>
                    </div>
                </div>
                {/if}
                {#if step2}
                <div class="row">
                    <div class="mb-3 text-center">
                        <h6>รีเซ็ตรหัสผ่าน</h6>
                    </div>
                    <div class="mb-3">
                        <label for="exampleFormControlInput1" class="form-label"><Fa icon={faMobileScreenButton} /> OTP</label>
                        <div class="row">
                            <div class="col-3 p-1">
                                <input type="text" class="form-control rounded-pill text-center mobile-verify" maxlength="1" placeholder="" bind:value={otp_num1} bind:this={otp1} on:keyup={() => otp2.focus()}>
                            </div>
                            <div class="col-3 p-1">
                                <input type="text" class="form-control rounded-pill text-center mobile-verify" maxlength="1" placeholder="" bind:value={otp_num2} bind:this={otp2} on:keyup={() => otp3.focus()}>
                            </div>
                            <div class="col-3 p-1">
                                <input type="text" class="form-control rounded-pill text-center mobile-verify" maxlength="1" placeholder="" bind:value={otp_num3} bind:this={otp3} on:keyup={() => otp4.focus()}>
                            </div>
                            <div class="col-3 p-1">
                                <input type="text" class="form-control rounded-pill text-center mobile-verify" maxlength="1" placeholder="" bind:value={otp_num4} bind:this={otp4} >
                            </div>
                        </div>
                        
                        
                    </div>
                    <div class="col-12 text-center d-grid gap-2">
                        <button type="button" class="btn btn-dark rounded-pill btn-gd" on:click={() => setStep2()} >ถัดไป <Fa icon={faCircleRight} /></button>
                    </div>
                </div>
                {/if}
                {#if step3}
                <div class="row">
                    <div class="mb-3 text-center">
                        <h6>รีเซ็ตรหัสผ่าน</h6>
                    </div>
                    <div class="mb-3">
                        <label for="password" class="form-label"><Fa icon={faKey} /> รหัสผ่าน</label>
                        <input type="password" class="form-control rounded-pill text-center" id="password" placeholder="" bind:value={password} >
                    </div>
                    <div class="mb-3">
                        <label for="password2" class="form-label"><Fa icon={faLock} /> ยืนยันรหัสผ่าน</label>
                        <input type="password" class="form-control rounded-pill text-center" id="password2" placeholder="" bind:value={password2} >
                    </div>
                    <div class="col-12 text-center d-grid gap-2">
                        <button type="button" class="btn btn-dark rounded-pill btn-gd" on:click={() => setStep3()} >ถัดไป <Fa icon={faCircleRight} /></button>
                    </div>
                </div>
                {/if}
            </div>
          </div>
    </div>
</div>
